import { render, staticRenderFns } from "./assignments-form.vue?vue&type=template&id=7c0d1e74&scoped=true&"
import script from "./assignments-form.vue?vue&type=script&lang=js&"
export * from "./assignments-form.vue?vue&type=script&lang=js&"
import style0 from "./assignments-form.vue?vue&type=style&index=0&id=7c0d1e74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d1e74",
  null
  
)

export default component.exports